import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import {decodeQuery} from "../common/utils";
import {ua} from "../common/utils/webtool";
import {store} from "../plugins";

Vue.use(VueRouter);
const router = new VueRouter({
	scrollBehavior: () => ({x: 0, y: 0}),
	routes,
	mode: "hash",
	base: "",
});
router.afterEach((to, from) => {
	// console.log("to", to.path);
	if (to.path == "/main/tpys") {
		gevt("页面浏览", "视图事件", "图片压缩", "None", store.VIPState, "None");
	} else if (to.path == "/main/spys") {
		gevt("页面浏览", "视图事件", "视频压缩", "None", store.VIPState, "None");
	} else if (to.path == "/main/pdfys") {
		gevt("页面浏览", "视图事件", "PDF压缩", "None", store.VIPState, "None");
	} else if (to.path == "/main/wordys") {
		gevt("页面浏览", "视图事件", "Word压缩", "None", store.VIPState, "None");
	} else if (to.path == "/main/pptys") {
		gevt("页面浏览", "视图事件", "PPT压缩", "None", store.VIPState, "None");
	}
});

//chunk404处理
// router.onError((error) => {
// 	const pattern = /chunk/;
// 	const isChunkFailed = error.message.match(pattern);
// 	const targetPath = router.history.pending.fullPath;
// 	if (isChunkFailed) {
// 		router.replace(targetPath);
// 	}
// });
// if (/h_=\d/.test(location.hash))
// 	history.replaceState(null, null, location.href.replace(/h_=\d+/, "h_=0"));
// VueRouter.prototype.push = (function (_push) {
// 	return function (location) {
// 		if (typeof location === "string") location = {path: location};
// 		let h_ = (router.currentRoute.query.h_ || 0) + 1;
// 		if (location.query) location.query.h_ = h_;
// 		else location.query = {h_};
// 		return _push.call(this, location);
// 	};
// })(VueRouter.prototype.push);
// VueRouter.prototype.replace = (function (_replace) {
// 	return function (location) {
// 		if (typeof location === "string") location = {path: location};
// 		if (location.query) location.query.h_ = router.currentRoute.query.h_;
// 		else location.query = {h_: 0};
// 		return _replace.call(this, location);
// 	};
// })(VueRouter.prototype.replace);
// VueRouter.prototype.back = function () {
// 	if (router.currentRoute.query.h_ > 0) this.go(-1);
// 	else this.replace(router.currentRoute.query.f || "/");
// };

// router.beforeEach(function (to, from, next) {
// 	if (to.path == "/start") {
// 		next();
// 	} else if (to.path == "/login") {
// 		if (store.user.online) store.user.logout();
// 		else {
// 			var query = decodeQuery(location.search.slice(1));
// 			if (query.code)
// 				store.user.wxLoginOrRegister(query.code, {mp: true}).then(
// 					(x) => {
// 						if (!query.state) next({path: "/"});
// 						else if (query.state.startsWith(ua.baseURL))
// 							next({path: query.state.slice(ua.baseURL.length)});
// 						else location.href = query.state;
// 					},
// 					(_) => next()
// 				);
// 			else next();
// 		}
// 		next();
// 	} else if (to.meta.login !== false && !store.user.online) {
// 		if (store.user.online == null)
// 			// 不确定是否在线
// 			store.user.checkLogin({force: true}).then(function (x) {
// 				return x ? next() : next({path: "/login", query: {f: to.fullPath}});
// 			});
// 		else next({path: "/login", query: {f: to.fullPath}});
// 	} else {
// 		next();
// 	}
// });

export default router;
